import Ratings from './Ratings';
export default Ratings;
